import React, {CSSProperties} from 'react';
import MuiPaper, {PaperProps} from '@mui/material/Paper';

type Props = {
    expand?: boolean;
    overlay?: boolean;
    center?: boolean;
    row?: boolean;
    column?: boolean;
    horizontal?: boolean;
    width?: string | number;
    height?: string | number;
    shadow?: boolean;
    round?: boolean;
    padding?: string | number;
    marginBottom?: string | number;
    margin?: string | number;
    style?: CSSProperties;
} & PaperProps

const Paper: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (props, ref) => {

    let {
        expand,
        overlay,
        center,
        row,
        column,
        horizontal,
        width,
        height,
        shadow,
        round,
        padding,
        marginBottom,
        margin,
        style = {},
        ...rest
    } = props;

    if (margin) {
        style["margin"] = margin;
    }

    if (padding) {
        style["padding"] = padding;
    }

    if (marginBottom) {
        style["marginBottom"] = marginBottom;
    }

    if (row) {
        style["display"] = "flex";
    }

    if (column) {
        style["display"] = "flex";
        style["flexDirection"] = "column";
    }

    if (expand || overlay) {
        width = "100%";
        height = "100%";
    }

    if (overlay) {
        style["pointerEvents"] = "none";
        style["position"] = "fixed";
        style["zIndex"] = 1;
    }

    if (center) {
        style["display"] = "flex";
        style["flexDirection"] = horizontal || row ? "row" : "column";
        style["justifyContent"] = "center";
        style["alignItems"] = "center";
    }

    if (shadow) {
        style["boxShadow"] = "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 3px 1px -2px rgba(0, 0, 0, 0.24), 0 1px 5px 0 rgba(0, 0, 0, 0.5)";
    }

    if (round) {
        style["borderRadius"] = "4px";
    }

    // @ts-ignore
    return <MuiPaper
            ref={ref}
            width={width}
            height={height}
            style={style}
            {...rest}
    />
};

export default React.forwardRef(Paper)
